//Replaces '\n' in a string with a break tag

export const newLineDelimiter = (text: string) => {
    const output = text.split('\\n').map((segment: string, index: number) => {
        return <Line segment={segment} key={index} />
    })

    return output
}

interface LineProps {
    segment: string
}

const Line = (props: LineProps) => {
    return (
        <>
            {props.segment}
            <br />
        </>
    )
}
